export default function setCookie({
  name,
  value,
  path = '/',
  session = false,
  domain,
  expires,
}) {
  const expiresValue = session ? '' : `expires=${expires.toUTCString()}; `;
  const domainValue = domain ? ` domain=${domain};` : '';

  document.cookie = `${name}=${value};${domainValue} ${expiresValue}path=${path};`;
}
